import React, { forwardRef } from 'react';
import { useKeyboardShortcut } from 'src/hooks';
import { IconName } from 'src/components';
import * as S from './styles';

// Allow `any`s for awkward styled-components types
/* eslint @typescript-eslint/no-explicit-any: "off" */

export const ButtonColor = {
  GREEN: 'green',
  GREY: 'grey',
  YELLOW: 'yellow',
} as const;
export type ButtonColor = (typeof ButtonColor)[keyof typeof ButtonColor];

export interface BaseButtonProps {
  buttonColor: ButtonColor;
  children?: React.ReactNode;
  className?: string;
  vertical: boolean;
  icon: IconName;
}

interface ButtonProps extends React.HTMLProps<HTMLButtonElement>, BaseButtonProps {
  onClick?: (event?: React.MouseEvent<HTMLButtonElement>) => void | Promise<void> | null;
}

export const Button = forwardRef(function InnerButton(
  { as, buttonColor, children, className, icon, onClick, vertical = false, ...rest }: ButtonProps,
  ref,
) {
  useKeyboardShortcut('', onClick);

  return (
    <S.Variables
      styleProps={{
        $buttonColor: buttonColor,
        $vertical: vertical,
      }}
    >
      <S.Container $vertical={vertical} className={className}>
        <S.Button
          onClick={onClick}
          $vertical={vertical}
          type="button"
          ref={ref}
          as={as as any}
          {...rest}
        >
          <S.Icon name={icon} $vertical={vertical} />
          {children}
        </S.Button>
      </S.Container>
    </S.Variables>
  );
});
